// Sort options for the enrollments list (sent as the `sort` query param).
// See ClickUp 868jxkz4p §3.
export const ENROLLMENT_SORTS = [
  { id: "started_at_desc", label: "Mais recentes" },
  { id: "started_at_asc", label: "Mais antigos" },
  { id: "members_count_desc", label: "Mais membros" },
  { id: "members_count_asc", label: "Menos membros" },
  { id: "revenue_desc", label: "Maior receita" },
  { id: "ends_at_asc", label: "Mentoria encerra primeiro" },
  { id: "split_ends_at_asc", label: "Repasse encerra primeiro" },
];

export const DEFAULT_ENROLLMENT_SORT = "started_at_desc";

export const ENROLLMENT_SORT_LABEL = ENROLLMENT_SORTS.reduce(
  (acc, sort) => ({ ...acc, [sort.id]: sort.label }),
  {}
);
